module.exports = __webpack_public_path__ + "static/img/numier-blue-background.dc21666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/numier-blue-background.png
// module id = 1gkc
// module chunks = 4